import { render, staticRenderFns } from "./plus_details.vue?vue&type=template&id=20180e6a&scoped=true&"
import script from "./plus_details.vue?vue&type=script&lang=js&"
export * from "./plus_details.vue?vue&type=script&lang=js&"
import style0 from "./plus_details.vue?vue&type=style&index=0&id=20180e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20180e6a",
  null
  
)

export default component.exports